import React from 'react';
import { useI18n } from '../../lib/i18n';
import { Reveal } from '../ui/Reveal';
export function HowItWorks() {
  const {
    t
  } = useI18n();
  const steps = [{
    num: '01',
    title: t('hw1Title'),
    desc: t('hw1Desc')
  }, {
    num: '02',
    title: t('hw2Title'),
    desc: t('hw2Desc')
  }, {
    num: '03',
    title: t('hw3Title'),
    desc: t('hw3Desc')
  }, {
    num: '04',
    title: t('hw4Title'),
    desc: t('hw4Desc')
  }];
  return <section id="how-it-works" className="py-24 md:py-32 relative bg-luxury-cream border-t border-luxury-taupe/10" data-id="element-99">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-100">
        <Reveal data-id="element-101">
          <div className="text-center mb-20" data-id="element-102">
            <h2 className="text-3xl md:text-4xl font-heading font-medium text-luxury-charcoal mb-4" data-id="element-103">
              {t('hwTitle')}
            </h2>
            <div className="w-12 h-px bg-luxury-gold mx-auto" data-id="element-104" />
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-105">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-px bg-luxury-taupe/20" data-id="element-106" />

          {steps.map((step, idx) => <Reveal key={idx} delay={idx * 150} data-id="element-107">
              <div className="relative flex flex-col items-center text-center group" data-id="element-108">
                <div className="w-24 h-24 rounded-full bg-luxury-warmgray/60 border border-luxury-taupe/20 flex items-center justify-center mb-8 relative z-10 group-hover:border-luxury-gold/50 transition-colors duration-500" data-id="element-109">
                  <span className="text-2xl font-heading text-luxury-gold font-light" data-id="element-110">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-lg font-medium text-luxury-charcoal mb-4" data-id="element-111">
                  {step.title}
                </h3>
                <p className="text-sm text-luxury-stone font-light leading-relaxed max-w-[250px]" data-id="element-112">
                  {step.desc}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}